import React from 'react';
import Hero from './Hero';
import Intro from './Intro';
import Navbar from './Navbar';
import Streamers from './Streamers';
import Roadmap from './Roadmap';
import NFTs from './NFTs';
import Features from './Features';
import GoPremium from './GoPremium';
import Tokenomics from './Tokenomics';
import Tournament from './Tournament';
import TopTeams from './TopTeams';
import Betting from './Betting';
import NewsFeed from './NewsFeed';
import Testimonial from './Testimonial';
import Footer from './Footer';
import ExtraElements from './ExtraElements';

const MainPage = () => {

    return (
        // <!-- Starts -->
    <div className="wrapper">
    <Navbar></Navbar>
    {/* <!--Starts Main Area--> */}
    <main id="main">
      <Hero></Hero>
      <Intro></Intro>
      <Streamers></Streamers>
      <Roadmap></Roadmap>
      <NFTs></NFTs>
      <Features></Features>
      <GoPremium></GoPremium>
      <Tokenomics></Tokenomics>
      <Tournament></Tournament>
      <TopTeams></TopTeams>
      <Betting></Betting>
       <NewsFeed></NewsFeed>
      <Testimonial></Testimonial> 

    </main>
    {/* <!--Ends Main Area--> */}
    {/* <!--Starts Extra Elements Area--> */}
    <ExtraElements></ExtraElements>
    {/* <!--Ends Extra Elements Area-- */}
    <Footer></Footer>
  </div>
  // <!--  End -->
    );
};

export default MainPage;